<app-header></app-header>
<div class="container-fluid bg-features py-24" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <p class="text-center text-5xl font-bold text-white">Enroll</p>
    <p class="pt-8 text-4xl text-center font-bold text-white">Accelerate Your Admissions</p>
    <p class="text-2xl text-center text-white pt-4">Journey with Enroll's Cutting-Edge Features!</p>
  </div>
</div>

<div class="container mx-auto p-4 mt-10 md:mt-20">
  <div class="bg-white shadow-md rounded-2xl overflow-hidden">
<!--    <div class="relative" style="padding-top: 40%;">-->
      <video poster="assets/video-thum.png" controls>
        <source src="assets/Enroll Intro final.webm">
      </video>
<!--      <iframe class="absolute inset-0 w-full h-full" src="https://www.youtube.com/embed/ffqhigwoass?si=gMd-wElk7zRBMBb2"-->
<!--              title="YouTube video player" frameborder="0"-->
<!--              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"-->
<!--              referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>-->
<!--    </div>-->
  </div>
</div>

<div class="container-fluid mt-10 md:mt-20" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <p class="text-center text-3xl md:text-4xl font-semibold">Powerful & advanced Management of Sales</p>
    <div class="mt-8 md:mt-16 p-2">
      <img src="/assets/images/features-images/features2.png" alt="image" class="w-full"/>
    </div>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-20" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <div class="flex flex-col md:flex-row gap-4">
      <div class="w-full md:w-1/2 p-4">
        <p class="text-xl md:text-4xl mb-2 font-semibold">Student Admission Portal</p>
        <p class="pt-2 text-lg md:text-xl text-zinc-500 text-justify">Centralized database for managing and storing admissions data. Enter the
          Student Admission Portal, which is intended to simplify and customize each student's enrollment process.</p>
        <ul class="pt-8 ps-4 md:ps-0 list-disc text-zinc-500">
          <li class="text-lg md:text-xl">Dynamic Dashboard</li>
          <li class="text-lg md:text-xl">Query Management System</li>
          <li class="text-lg md:text-xl">Post Application Process</li>
        </ul>
      <div class="w-full flex justify-center md:justify-start">
        <button
          class="mt-12 flex items-center px-6 py-3 text-xl bg-[#6752A9] text-white rounded-lg btn-pulse transition whitespace-nowrap duration-200"
          (click)="goTo('auth/register')">
          Enroll Today
          <img src="./assets/images/tilted-arrow.png" width="34" height="27" class="ml-2" alt="Arrow Icon">
        </button>
      </div>
      </div>
      <div class="w-full md:w-1/2 p-4 flex justify-center items-center">
        <img src="/assets/images/features-images/features3.png" alt="Image" class="max-w-full">
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-20" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <div class="flex flex-col md:flex-row gap-4">
      <div class="w-full md:w1/2 p-4">
        <img src="/assets/images/features-images/features4.png" alt="Image" class="w-full"/>
      </div>
      <div class="w-full md:w1/2 p-4">
        <p class="text-xl md:text-4xl font-semibold">Online Application Management</p>
        <p class="pt-2 text-lg md:text-xl text-zinc-500 text-justify">Enroll's streamlined application process simplifies and automates every
          step. The
          Application
          Manager streamlines the workflow, enabling you to quickly handle any departmental or cross-channel
          activity.</p>
        <ul class="pt-8 ps-4 md:ps-0 list-disc text-zinc-500">
          <li class="text-lg md:text-xl">Advanced Application Filters</li>
          <li class="text-lg md:text-xl">Hassle-Free Data Uploads</li>
          <li class="text-lg md:text-xl">Daily Tracker</li>
        </ul>
      </div>
    </div>
  </div>
</div>

<div class="container mx-auto mt-10 md:mt-20" [style.font-family]="'var(--vex-font)'">
  <div class="flex flex-wrap gap-8 justify-center items:center">
    <div
      class="w-2/2 h-full md:w-1/3  shadow-md rounded-lg overflow-hidden bg-gray-100 border border-black hover-effect">
      <div class="p-8">
        <div class="mb-4">
          <h2 class="text-xl md:text-2xl">Mobile Access</h2>
          <ul class=" pt-8 md:pt-12 lg:pt-8">
            <li class="md:text-lg text-zinc-500"><i class="fa fa-check-circle-o text-xl md:text-2xl tick-green" aria-hidden="true"></i> Automate
              check-ins & check-outs
            </li>
            <li class="md:text-lg text-zinc-500"><i class="fa fa-check-circle-o text-xl md:text-2xl tick-green" aria-hidden="true"></i> Optimize
              spending & ROI
            </li>
            <li class="md:text-lg text-zinc-500"><i class="fa fa-check-circle-o text-xl md:text-2xl tick-green" aria-hidden="true"></i> Manage
              queries easily, while on the move
            </li>
          </ul>
        </div>
        <div class="flex justify-center">
          <img src="/assets/images/features-images/features5.png" alt="Image 1" class="max-w-full">
        </div>
      </div>
    </div>

    <div
      class="w-2/2 md:w-1/3 h-full shadow-md rounded-lg overflow-hidden bg-gray-100 border border-black hover-effect">
      <div class="p-8">
        <div class="mb-4">
          <h2 class="text-xl md:text-2xl">Communication Management</h2>
          <ul class="pt-8">
            <li class="md:text-lg text-zinc-500"><i class="fa fa-check-circle-o text-2xl tick-green" aria-hidden="true"></i> IVR calling
              option
            </li>
            <li class="md:text-lg text-zinc-500"><i class="fa fa-check-circle-o text-2xl tick-green" aria-hidden="true"></i>
              Communication through WhatsApp
            </li>
            <li class="md:text-lg text-zinc-500"><i class="fa fa-check-circle-o text-2xl tick-green" aria-hidden="true"></i> SMS Campaign
            </li>
          </ul>
        </div>
        <div class="flex justify-center lg:pt-6 pt-0">
          <img src="/assets/images/features-images/features6.png" alt="Image 2" class="max-w-full">
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-20 bg-purple py-8">
  <div class="container p-2">
    <p class="md:text-4xl text-2xl font-semibold text-center">Analytics and Reporting</p>
    <div class="mt-8 flex justify-center">
    <img src="/assets/images/features-images/bg-purple-image.png" alt="Image" class="" style="opacity: 0.9;"/>
    </div>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-20" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <div class="flex flex-col md:flex-row gap-4">
      <div class="w-full md:w1/2 p-4 flex justify-center items-center">
        <img src="/assets/images/features-images/features8.png" alt="Image" class="max-w-full"/>
      </div>
      <div class="w-full md:w1/2 p-4">
        <p class="text-2xl md:text-4xl font-semibold">User Management</p>
        <p class="text-lg md:text-xl pt-2 text-zinc-500 text-justify">The system administrator panel allows for various stakeholder roles,
          including super
          admin,
          university admin, and applicants, and ensures secure authentication and authorization mechanisms.</p>
        <ul class="p-8 list-disc text-zinc-500">
          <li class="text-lg md:text-xl">Manage user accounts securely with Advanced User Manager</li>
          <li class="text-lg md:text-xl">Ensure optimum security with Advanced Data Masking</li>
          <li class="text-lg md:text-xl">Keep track of all sessions with User Activity Logs</li>
        </ul>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt-4 md:mt-20" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <div class="flex flex-col md:flex-row gap-4">
      <div class="w-full md:w-1/2 p-4">
        <p class="text-2xl md:text-4xl mb-2 font-semibold">Lead Management</p>
        <p class="text-lg md:text-xl text-zinc-500 text-justify">Manage, distribute, and centralize all incoming leads and inquiries that are
          obtained from various sources to seize every chance and solve the widespread issue of lead duplication and
          leakage in the industry.</p>
        <ul class="p-8 list-disc text-zinc-500">
          <li class="text-lg md:text-xl">Ensure Zero Lead Leakage</li>
          <li class="text-lg md:text-xl">Eliminate Lead Duplication</li>
          <li class="text-lg md:text-xl">Auto Verify Leads to Optimize Your Efforts</li>
        </ul>
      </div>
      <div class="w-full md:w-1/2 p-4 flex justify-center items-center bg-features9 rounded-2xl">
        <img src="/assets/images/features-images/features9.gif" alt="Image" class="rounded-2xl">
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-20 bg-pink p-8">
  <div class="container p-2">
    <p class="text-2xl md:text-4xl text-center font-semibold">Add Multiple Institutions</p>
    <p class="text-lg md:text-xl text-center pt-2 text-zinc-500">Manage Students and their admissions, Exams, Tracking, Data 10X
      faster.</p>
    <img src="/assets/images/features-images/create-admin.png" alt="Image" class="w-full mt-8"/>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-20" style="font-family: var(--vex-font);">
  <div class="container">
    <p class="text-2xl md:text-4xl mb-2 text-center font-semibold">Powerful features to advanced analytics to manage Admissions</p>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8">
      <div class="p-4 bg-white shadow-md rounded-lg hover-effect">
        <img src="/assets/images/features-images/features11.png" alt="Image" class="max-w-full h-auto">
        <h2 class="md:text-2xl text-xl mt-4 text-center">Secured Platform</h2>
        <p class="md:text-lg mt-2 text-center text-zinc-500">Enroll’s fortified platform ensures data safety and security
          through robust measures like encryption and regular audits, prioritizing the protection of sensitive
          admissions data.</p>
      </div>
      <div class="p-4 bg-white shadow-md rounded-lg hover-effect">
        <img src="/assets/images/features-images/features12.png" alt="Image" class="max-w-full h-auto">
        <h2 class="md:text-2xl text-xl mt-4 text-center">Advanced Analytics</h2>
        <p class="md:text-lg mt-2 text-center text-zinc-500">Enroll offers advanced analytics for real-time data analysis,
          enabling informed decision-making and optimization of recruitment strategies in the admissions process.</p>
      </div>
      <div class="p-4 bg-white shadow-md rounded-lg hover-effect">
        <img src="/assets/images/features-images/features13.png" alt="Image" class="max-w-full h-auto">
        <h2 class="md:text-2xl text-xl text-center">Powerful Automation</h2>
        <p class="md:text-lg text-center text-zinc-500">Enroll’s automation features streamline application processing
          and communication workflows, saving time and resources and enhancing the admissions experience for staff and
          applicants.</p>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-20" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <div class="flex flex-col md:flex-row gap-4">
      <div class="w-full md:w-1/2 p-4">
        <p class="md:text-4xl text-2xl mb-2 font-semibold">Accounts Management</p>
        <p class="text-lg md:text-xl pt-2 text-zinc-500 text-justify">Enroll’s Accounts Management feature simplifies your tasks, enhances accuracy, and saves you time. It
        facilitates the tracking of payments, balances, and account settings to ensure accurate and efficient financial
          operations on your finger-tips.</p>
        <ul class="p-8 list-disc text-zinc-500">
          <li class="text-lg md:text-xl">Effortless Financial Tracking</li>
          <li class="text-lg md:text-xl">Real-Time Insights</li>
          <li class="text-lg md:text-xl">Seamless Integration</li>
          <li class="text-lg md:text-xl">Automated Reporting</li>
        </ul>
      </div>
      <div class="w-full md:w-1/2 p-4 flex justify-center items-center rounded-2xl bg-features14">
        <img src="/assets/images/features-images/features14.gif" alt="Image" class="rounded-2xl">
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-20" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <div class="flex flex-col md:flex-row gap-4">
      <div class="w-full md:w1/2 p-4 flex justify-center items-center">
        <img src="/assets/images/features-images/features8.png" alt="Image" class="max-w-full"/>
      </div>
      <div class="w-full md:w1/2 p-4">
        <p class="md:text-4xl text-2xl font-semibold">Payment Management</p>
        <p class="text-lg md:text-xl pt-2 text-zinc-500 text-justify">Integration with payment gateways for application fees, tuition deposits,
          and other
          payments</p>
        <ul class="p-8 list-disc text-zinc-500">
          <li class="text-lg md:text-xl">Bouquet of Payment Options</li>
          <li class="text-lg md:text-xl">Automatic Split Payment</li>
          <li class="text-lg md:text-xl">One View Purchase Summary</li>
        </ul>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt-8 md:mt-20 p-4" [style.font-family]="'var(--vex-font)'">
  <div class="container border border-purple-700 bg-violet-100 rounded-2xl bg-red-300">
    <div class="flex flex-wrap">
      <div class="w-full md:w-1/3 md:pt-20 md:mt-16">
        <div class="pt-8 md:pt-20">
          <p class="text-2xl md:text-4xl text-center font-semibold">Powerful features to advanced analytics to manage Admissions</p>
        </div>
      </div>
      <div class="w-full md:w-1/3 pt-0 md:pt-20 lg:pt-36">
        <div class="p-4">
          <img src="/assets/images/features-images/features16.png" alt="Image" class="max-w-full h-auto">
        </div>
      </div>
      <div class="w-full md:w-1/3 p-4">
        <div class="p-4 flex flex-col justify-between">
          <div class="mb-4">
            <img src="/assets/images/features-images/features17.png" alt="Image" class="max-w-full h-auto">
          </div>
          <div>
            <img src="/assets/images/features-images/features18.png" alt="Image" class="max-w-full h-auto">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid md:mt-20 mt-10">
  <div class="container">
    <div class="text-center">
      <div class="md:text-4xl text-2xl font-extrabold">User-centric development</div>
    </div>
    <div
      class="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
      <div *ngFor="let item of items" class="flex gap-3">
        <mat-icon
          [svgIcon]="item.icon"
          class="flex-none text-green-600 mt-0.5"></mat-icon>
        <div>
          <div class="text-lg font-medium">{{ item.label }}</div>
          <div class="text-gray-500 text-sm mt-1 leading-relaxed text-justify">
            {{ item.description }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-20 bg-consultancy py-12" [style.font-family]="'var(&#45;&#45;vex-font)'">
  <div class="container">
    <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2  ">
      <div class="">
        <div class="w-full flex justify-center md:justify-start">
          <img src="assets/images/Chat.png" alt="Image" class="py-5"/>
        </div>
        <h1 class="font-inter text-white text-3xl font-medium text-center md:text-start">Get a free consultation from our expert</h1>
        <h1 class="font-inter text-white text-5xl font-bold text-center md:text-start"> Right Now!</h1>
        <p class="text-white text-xl pt-3 pb-20 text-center md:text-start">Discover what's possible with Arni University. Let's Innovate, Grow, and Succeed together.</p>
      </div>
      <div class="md:relative lg:relative flex justify-end">
        <div class="bg-white px-8 mt-2 md:mt-20 rounded-lg w-full max-w-lg md:absolute lg:absolute">
          <form class="p-6 flex flex-col gap-4" [formGroup]="addEnquiryForm" (ngSubmit)="submit()">
            <p class="text-center text-2xl font-semibold text-maroon mb-4">Request For a Free Consultation & see the difference!</p>
            <div class="flex flex-col gap-4">
              <div class="relative pb-2">
                <label for="name" class="block text-lg font-medium text-gray-700 mb-1">Name</label>
                <input id="name" formControlName="name" type="text" placeholder="John Doe"
                       class="block w-full px-4 py-2 border rounded-md border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out"
                       required>
                <small class="absolute text-red-600 text-xs italic mt-1"
                       *ngIf="submitted && addEnquiryForm.get('name').hasError('required')">
                  Name field is required
                </small>
              </div>
              <div class="relative pb-2">
                <label for="email" class="block text-lg font-medium text-gray-700 mb-1">Email</label>
                <input id="email" formControlName="email" type="email" placeholder="abctestmail@gmail.com"
                       class="block w-full px-4 py-2 border rounded-md border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out"
                       required>
                <small class="absolute text-red-600 text-xs italic mt-1"
                       *ngIf="submitted && addEnquiryForm.get('email').hasError('required')">
                  Email field is required
                </small>
                <small class="absolute text-red-600 text-xs italic mt-1"
                       *ngIf="submitted && addEnquiryForm.get('email').hasError('pattern')">
                  Invalid email format
                </small>
              </div>
              <div class="relative pb-2">
                <label for="contact" class="block text-lg font-medium text-gray-700 mb-1">Phone Number</label>
                <input id="contact" formControlName="contact" type="tel" placeholder="+91-7836899999"
                       class="block w-full px-4 py-2 border rounded-md border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out"
                       required>
                <small class="absolute text-red-600 text-xs italic mt-1"
                       *ngIf="submitted && addEnquiryForm.get('contact').hasError('required')">
                  Contact field is required
                </small>
              </div>
              <div class="relative pb-2">
                <label for="subject" class="block text-lg font-medium text-gray-700 mb-1">Subject</label>
                <input id="subject" formControlName="subject" type="text" placeholder="Subject"
                       class="block w-full px-4 py-2 border rounded-md border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out"
                       required>
                <small class="absolute text-red-600 text-xs italic mt-1"
                       *ngIf="submitted && addEnquiryForm.get('subject').hasError('required')">
                  Subject field is required
                </small>
              </div>
              <button type="submit"
                      class="table-header-color text-white py-3 mt-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out">
                Get a Call Back
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-72 bg-faq py-20" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <p class="text-center text-2xl md:text-4xl font-semibold">
      Frequently Asked Questions
    </p>
    <div class="flex flex-col md:flex-row justify-between items-center gap-8 pt-8">
      <div class="flex-1 flex-shrink-0">
        <img src="/assets/images/features-images/faq3.jpeg" alt="FAQ Image" class="w-full md:h-96 rounded-2xl"/>
      </div>
      <div class="flex-1 flex flex-col">
        <div class="flex-1 flex flex-col md:max-w-xl px-1 md:px-0">
          <mat-accordion class="p-2 flex-1">
            <mat-expansion-panel class="py-8 md:py-2 border-solid-purple">
              <mat-expansion-panel-header class="flex items-center">
                <mat-panel-title class="flex-1">
                  <div class="max:w-[15%] min:w-[15%]">
                    <mat-icon class="text-maroon text-lg md:text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
                  </div>
                  <span class="ml-2 max:w-[85%] min:w-[85%]">
                    How can Enroll benefit my institution?
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="para-border mt-5 pt-2 md:pt-0 md:mt-0 text-justify text-zinc-500">
                After integrating Enroll software, one can automate and control the entire admission process, from collecting or filling out the query form to counseling to document verification and accomplishment of the admission.
              </p>
            </mat-expansion-panel>
            <mat-expansion-panel class="py-8 md:py-2 border-solid-purple">
              <mat-expansion-panel-header>
                <mat-panel-title class="flex-1">
                  <div class="max:w-[15%] min:w-[15%]">
                    <mat-icon class="text-maroon text-lg md:text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
                  </div>
                  <span class="ml-2 max:w-[85%] min:w-[85%]">
                    Can I manage several institutions with Enroll?
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="para-border mt-5 pt-2 text-justify text-zinc-500">
                Absolutely, Enroll offers a multi-university feature that helps the organization to manage and control several universities under one roof with ease and efficiency.
              </p>
            </mat-expansion-panel>
            <mat-expansion-panel class="py-8 md:py-2 border-solid-purple">
              <mat-expansion-panel-header>
                <mat-panel-title class="flex-1">
                  <div class="max:w-[15%] min:w-[15%]">
                    <mat-icon class="text-maroon text-lg md:text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
                  </div>
                  <span class="ml-2 max:w-[85%] min:w-[85%]">
                    What kind of communication support we will get through Volmint’s Enroll?
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="para-border mt-5 pt-2 text-justify text-zinc-500">
                The users can connect with applicants at a deeper level, and the personalized tools help to communicate via SMS, WhatsApp, and IVR calling options.
              </p>
            </mat-expansion-panel>
            <mat-expansion-panel class="py-8 md:py-2 border-solid-purple">
              <mat-expansion-panel-header>
                <mat-panel-title class="flex-1">
                  <div class="max:w-[15%] min:w-[15%]">
                    <mat-icon class="text-maroon text-lg md:text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
                  </div>
                  <span class="ml-2 max:w-[85%] min:w-[85%]">
                    Can we manage our social media leads?
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="para-border mt-5 pt-2 text-justify text-zinc-500">
                Yes, Enroll’s lead management feature lets you manage leads from various platforms to convert them into admissions without any hassle. Also, users can add leads manually for future use.
              </p>
            </mat-expansion-panel>
            <mat-expansion-panel class="py-8 md:py-2 border-solid-purple">
              <mat-expansion-panel-header>
                <mat-panel-title class="flex-1">
                  <div class="max:w-[15%] min:w-[15%]">
                    <mat-icon class="text-maroon text-lg md:text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
                  </div>
                  <span class="ml-2 max:w-[85%] min:w-[85%]">
                    Can we use Enroll on mobile?
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="para-border mt-5 pt-2 text-justify text-zinc-500">
                Indeed, candidates can receive automated alerts with Enroll Mobile Access about significant events, interview dates, and application deadlines. It could be improving student experiences, team productivity, enrollment rates, or marketing budget efficiency.
              </p>
            </mat-expansion-panel>
            <mat-expansion-panel class="py-8 md:py-2 border-solid-purple">
              <mat-expansion-panel-header>
                <mat-panel-title class="flex-1">
                  <div class="max:w-[15%] min:w-[15%]">
                    <mat-icon class="text-maroon text-lg md:text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
                  </div>
                  <span class="ml-2 max:w-[85%] min:w-[85%]">
                    How do I manage support through the software?
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="para-border mt-5 pt-2 text-justify text-zinc-500">
                Enroll’s support management feature helps applicants and institute staff use the system effectively by providing them with information and support. With unparalleled efficiency, respond to student inquiries, boosting enrollment and elevating student satisfaction.
              </p>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="above-footer py-12" [style.font-family]="'var(&#45;&#45;vex-font)'">
  <div class="container">
    <div class="m-auto text-center">
<!--      <img src="./assets/images/img-group.png" alt="" class="mx-auto">-->
      <h3 class="mt-5 text-white text-xl font-medium">
        Need any further assistance?
      </h3>
      <p class="mt-4 text-white ">
        Feel free to reach out for any inquiries or assistance.
      </p>
      <button type="button" class="mt-5 px-3 py-2 bg-white text-[#6752A9] rounded" (click)="goTo('/contact-us')">
        Book an appointment now!
      </button>
    </div>
  </div>
</div>
<app-footer></app-footer>

